import moment from 'moment'
import { createSelector } from 'reselect'
import { values } from 'lodash'

import { getStatus, makeSortRugs } from 'Global/Helpers/rugHelpers'
import { DESIGNER_QUEUE_START_DATE } from 'Global/constants'

const _page = state => state.layout.designerQueue.page
const _rugs = state => state.rugs.data

export const layout = state => state.layout.designerQueue.layout
export const limit = state => state.layout.designerQueue.limit
export const previewOpen = state => state.previewModal.designerQueue.visible
export const rugsDone = state => state.rugs.done
export const rugsError = state => state.rugs.error
export const rugsPending = state => state.rugs.pending
export const sortBy = state => state.layout.designerQueue.sortBy
export const sortOrder = state => state.layout.designerQueue.sortOrder
export const user = state => state.auth.user

/**
 * Iterates over all rugs and filters out all rugs
 * which aren't marked for designers.
 * @returns {array} Filtered Rugs
 */
export const filterRugs = createSelector(
  [sortBy, sortOrder, _rugs],
  (sortBy, sortOrder, rugs) => {
    const sort = makeSortRugs(sortBy, sortOrder)

    return values(rugs)
      .filter(r => {
        if (moment(r.dateScanned).isAfter(DESIGNER_QUEUE_START_DATE)) {
          if (r.pictureSource === 'station') {
            if (
              getStatus(r).text === 'In Stock' ||
              getStatus(r).text === 'Knotting' ||
              getStatus(r).text === 'On Consignment' ||
              getStatus(r).text === 'Unknown'
            ) {
              return true
            }
          }
        }

        return false
      })
      .sort(sort)
  },
)

/**
 * Takes the filtered rugs and slices the array to the set limit per page.
 */
export const slicedFilteredRugs = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return filteredRugs.slice((page - 1) * limit, (page - 1) * limit + limit)
  },
)

/**
 * Creates a pagination object with current page, total pages, total rugs
 */
export const calculatePagination = createSelector(
  [filterRugs, limit, _page],
  (filteredRugs, limit, page) => {
    return {
      page,
      pages: Math.ceil(filteredRugs.length / limit),
      totalRugs: filteredRugs.length,
    }
  },
)
